module.exports = __webpack_public_path__ + "static/fachada-tour-8e298102b1ec8892826b5adc98972184.jpg";